import { combineReducers } from 'redux'
import { reducer as form } from 'redux-form'
import { admins } from './admins'
import { coldWallets } from './coldWallets'
import { currencies } from './currencies'
import { custody } from './custody'
import { dashboard } from './dashboard'
import { depositDetails } from './depositDetails'
import { deposits } from './deposits'
import { govBr } from './govBr'
import { hotWallets } from './hotWallets'
import { kyc } from './kyc'
import { kycDetails } from './kycDetails'
import { markets } from './markets'
import { orderbook } from './orderbook'
import { pendencies } from './pendencies'
import { tradeFees } from './tradeFees'
import { user } from './user'
import { userDeposits } from './userDeposits'
import { userDetails } from './userDetails'
import { userOpenOrders } from './userOpenOrders'
import { userOrdersHistory } from './userOrdersHistory'
import { userTrades } from './userTrades'
import { userWallets } from './userWallets'
import { userWithdrawals } from './userWithdrawals'
import { users } from './users'
import { withdrawDetails } from './withdrawDetails'
import { withdrawFees } from './withdrawFees'
import { withdrawals } from './withdrawals'

export const reducers = combineReducers({
	form,
	user,
	pendencies,
	dashboard,
	coldWallets,
	hotWallets,
	currencies,
	custody,
	users,
	admins,
	kyc,
	userDetails,
	kycDetails,
	deposits,
	depositDetails,
	withdrawals,
	withdrawDetails,
	tradeFees,
	withdrawFees,
	orderbook,
	markets,
	userDeposits,
	userWithdrawals,
	userWallets,
	userOpenOrders,
	userOrdersHistory,
	userTrades,
	govBr,
})


// WEBPACK FOOTER //
// ./src/reducers/index.ts